import { render } from "./Popover.vue?vue&type=template&id=5382eecc"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"
script.render = render

export default script